// extracted by css-extract-rspack-plugin
var _1 = "accent__wNfrT";
var _2 = "header__Gzsg0";
var _3 = "header--closer__ARkHF";
var _4 = "header--contact-info__zlVjV";
var _5 = "header--sidebar-ified__X8EHJ";
var _6 = "header--with-description__XTDz_";
var _7 = "headerWrapper__ioyED";
var _8 = "headerWrapper--with-description__gEJz4";
var _9 = "subsection__Ua9X5";
var _a = "subsection--contact-info__wSUgN";
var _b = "subsection--stretch__a4ojn";
var _c = "subsection__description__wy75S";
var _d = "title__GDDOF";
export { _1 as "accent", _2 as "header", _3 as "header--closer", _4 as "header--contact-info", _5 as "header--sidebar-ified", _6 as "header--with-description", _7 as "headerWrapper", _8 as "headerWrapper--with-description", _9 as "subsection", _a as "subsection--contact-info", _b as "subsection--stretch", _c as "subsection__description", _d as "title" }
export default { "accent": _1, "header": _2, "header--closer": _3, "header--contact-info": _4, "header--sidebar-ified": _5, "header--with-description": _6, "headerWrapper": _7, "headerWrapper--with-description": _8, "subsection": _9, "subsection--contact-info": _a, "subsection--stretch": _b, "subsection__description": _c, "title": _d }
